<template>
<div style="height: 100%;background-color: white">工单记录</div>
</template>

<script>
export default {
  name: 'orderRecord'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/oldPersonHome/orderRecord.vue